import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";

const ResetPassword = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const handleClose = () => {
    setOpen(false);
    localStorage.setItem("compareGeoDialog", "shown");
  };

  return (
    <Stack>
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>
          <Typography variant="h6" color="#1B1B22" fontWeight={500}>
            Switching comparison focus
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Typography variant="body2" color="#515167">
            You are switching from comparing indices to comparing geographical
            units. In geographical unit focus, only one anomaly can be selected
            at a time for all units. Your previous selections will be restored
            if you switch back to indices comparison.
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{ justifyContent: "space-between", gap: 1, alignItems: "center" }}
        >
          <Stack direction="row" alignItems="center">
            <Checkbox size="small" />
            <Typography variant="body1">Do not show this again</Typography>
          </Stack>
          <Button
            variant="text"
            onClick={handleClose}
            sx={{ color: "#2146A4" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
};

export default ResetPassword;
